<template>
  <div id="activity">
  <van-card
  desc="活动时间：2020.10.1-2020.12.30"
  title="第一季演讲比赛"
  thumb="https://img.yzcdn.cn/vant/ipad.jpeg"
>
  <template #tags>
    <van-tag color="#f2826a" style="margin-left: 5px">火爆进行中</van-tag>
   
  </template>
  <template #footer>
    <van-button round type="info" size="mini" @click="toTouGao">报名参加</van-button>
  </template>
</van-card>
  </div>
</template>

<script>
import { Dialog } from 'vant';
  export default {
  methods: {
      toTouGao:function(){
         var phone = sessionStorage.getItem('phone');
         var userId = sessionStorage.getItem('userId');
         var openid = sessionStorage.getItem('openid');
         var isVoice = sessionStorage.getItem('isVoice');
         if(isVoice=='0'){
           function beforeClose(action, done) {
              if (action === 'confirm') {
                setTimeout(done, 1000);
                console.log('点击确定了....',userId)
                 this.$axios.get(
                  "http://ysj.fxiang.cn/xstWxUser/updateIsVoice/",
                  {params:{
                    userId:userId,
                    openid:openid
                    }}
                ).then(function(resp){
                  console.log("声明结果:"+resp)
                },function(err){
                  console.log("失败")
                })
              } else {
                done();
              }
            }
           Dialog.confirm({
              title: '语文报社声明',
              message: '<h4>投稿须知</h4>1、本社编辑部有权对稿件进行修删，不同意请在稿件中声明。<h4>联系方式</h4>名称：《语文报》社有限责任公司 \n地址：山西太原和平南路45号语文报社 \n联系部门：新媒体中心\n联系电话：6378025',
              messageAlign:'left',
              confirmButtonText:'同意并继续',
              cancelButtonText:'取消',
              beforeClose
            })
              .then(() => {
                 console.log("同意")
              })
              .catch(() => {
                  console.log("不同意")
                  this.$router.push({ path:'/ysj/activity'  })
              });
            console.log("未声明")
         }else{
           console.log("已声明")
         }
         console.log("phone:"+phone)
         if(phone === "null" || phone===""){
           console.log("没有电话")
             this.$router.push({ path:'/ysj/addUserInfo'  })
         } else {
           console.log("有电话")
           this.$router.push({ path:'/ysj/myFile'  })
           
         }
         
      }
},


}
</script>
